import { render, staticRenderFns } from "./QuotaSaleHistory.vue?vue&type=template&id=15af319e&scoped=true"
import script from "./QuotaSaleHistory.vue?vue&type=script&lang=js"
export * from "./QuotaSaleHistory.vue?vue&type=script&lang=js"
import style0 from "./QuotaSaleHistory.vue?vue&type=style&index=0&id=15af319e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af319e",
  null
  
)

export default component.exports